export const AuthActionTypes = {
    USER_SIGNUP_REQUEST: "USER_SIGNUP_REQUEST",
    USER_SIGNUP_SUCCESS: " USER_SIGNUP_SUCCESS",
    USER_SIGNUP_FAILURE: "USER_SIGNUP_FAILURE",
};
